import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {AuthenService} from "../../authen.service";
import {AppInfoService, BuildWithDate} from "../../services/app-info.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-dashboard',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  appInfo: BuildWithDate
  username: string;
  password: string;
  showPassword: boolean = false;
  bannerDismiss: boolean = false;
  private readonly BANNER_KEY = 'banner_20260703';
  @ViewChild("content", {static: true})
  private notifyModal: ElementRef;
  @ViewChild("bannerModal", {static: true})
  private bannerModal: ElementRef;

  constructor(public authenService: AuthenService,
              private _appInfoService: AppInfoService,
              private modalService: NgbModal) {

    this._appInfoService.appInfo.subscribe(e => this.appInfo = e)
  }

  ngOnInit(): void {
    //ประกาศจนถึงวันที่ 28 ก.พ. 2569
    // if (new Date() <= new Date(2026, 1, 28)) {
    //   this.modalService.open(this.notifyModal, {size: 'lg', keyboard: false, backdrop: 'static', centered: true});
    // }

    const now = new Date();
    const end = new Date(2026, 6, 3); // 2026-07-03
    const dismissed = localStorage.getItem(this.BANNER_KEY) === 'true';
    if (now <= end && !dismissed) {
      this.modalService.open(this.bannerModal, {size: 'lg', keyboard: false, backdrop: 'static', centered: true});
    }
  }

  onBannerDismissChange(): void {
    if (this.bannerDismiss) {
      localStorage.setItem(this.BANNER_KEY, 'true');
    } else {
      localStorage.removeItem(this.BANNER_KEY);
    }
  }

  login() {
    this.authenService.login(this.username, this.password);
  }

  clickShowPassword() {
    this.showPassword = !this.showPassword;
  }
}
